import React from 'react';

import siteBanner_img from '../assets/img/llc/sectionTopBanner.jpg';
import { PricingMenu, PricingContent } from "../components";

class Pricing extends React.Component {
  constructor() {
    super();

    this.state = {
      surgeryActive: 1
    }
  }

  changeActiveTab = (e) => {
    this.setState({
      surgeryActive: parseInt(e.currentTarget.id)
    })
  };

  render() {
    const langs = this.props.texts.langs;

    return (
      <div className="bc-beige2">
        <div className="siteBanner newBg no-print">
          <img src={siteBanner_img} className="siteBanner_bg"/>
          <h2 className="line">Ceník</h2>
        </div>
        <PricingMenu
          langs={{
            surgery: langs.surgery
          }}
          surgeryActive={this.state.surgeryActive}
          handleSurgeryClick={this.changeActiveTab}
        />
        <PricingContent
          langs={{
            pricing: langs.pricing,
            surgery: langs.surgery.find(sur => sur.id === this.state.surgeryActive)
          }}
          surgeryActive={this.state.surgeryActive}
        />
      </div>
    );
  }
}

export default Pricing;



// WEBPACK FOOTER //
// ./src/containers/Pricing.js